export default __webpack_public_path__ + "static/media/18.28e5a6a8.jpeg";